import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { Button } from 'react-bootstrap';


const Confirmation = ({ show, callback }) => {

    const handleClick = (event) => {
        console.log('handle click', event)
        callback(event);
    }

    const closeForm = () => {
        callback(true);
    }

    return (
        <div id="tet">
            <Modal
                id="delete-confirmation-test"
                className="delete-confirmation2" 
                show={show}
                onHide={closeForm}
                backdrop="statistic">
                    <Modal.Header closeButton>
                        <Modal.Title>Rivin poisto</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        Haluatko varmasti poistaa valitun rivin?
                    </Modal.Body>

                    <Modal.Footer>
                        <Button onClick={ () => handleClick('cancel') }>Peruuta</Button>
                        <Button onClick={ () => handleClick('confirm') }>Vahvista</Button>
                    </Modal.Footer>
            </Modal>                
        </div>
    )
}


export default Confirmation;
